<label class="switch">
  <!-- Input proxy -->
  <input type="checkbox" [checked]="checked" disabled />

  <!-- Slider -->
  <span class="slider" [class.danger]="danger">
    <!-- Left side -->
    <div class="left">
      <ion-icon [style.opacity]="_showLeftIcon ? 1 : 0" class="icon" [icon]="leftIcon"></ion-icon>
      <ion-spinner [style.opacity]="_showLeftSpinner ? 1 : 0" class="spinner" name="crescent"></ion-spinner>
    </div>

    <!-- Right side -->
    <div class="right">
      <ion-icon [style.opacity]="_showRightIcon ? 1 : 0" class="icon" [icon]="rightIcon"></ion-icon>
      <ion-spinner [style.opacity]="_showRightSpinner ? 1 : 0" class="spinner" name="crescent"></ion-spinner>
    </div>
  </span>
</label>
